<template>
    <div :id="`${baseId}`">
        <v-layout v-for="(rewards, index) in rewardsValues" :key="index" mb-3 :id="`${baseId}-rewards-${index}`">
            <v-flex xs12 :id="`${baseId}-rewards-${index}-flex`">
                <BrushstrokeBanner
                    :class="{ pad_for_upper_banner: rewards.upperBanner, reward_card_override_left_top_bottom_pad: shortView }"
                    :brushstrokeColor="rewards.background"
                    :parent-id="`${baseId}-rewards-${index}`"
                >
                    <v-layout v-if="rewards.upperBanner" class="violator" :id="`${baseId}-rewards-${index}-brushstroke-banner-upper-banner-layout`">
                        <div class="violator-text tx-font-primary" :id="`${baseId}-rewards-${index}-brushstroke-banner-upper-banner`">{{ rewards.upperBanner }}</div>
                    </v-layout>
                    <v-layout>
                        <div :class="[shortView ? 'small_reward_icon' : 'reward_icon']" :id="`${baseId}-rewards-${index}-brushstroke-banner-coin-image-container`">
                            <img :src="getCoinImage(rewards.background)" :id="`${baseId}-rewards-${index}-brushstroke-banner-coin-image`"/>
                        </div>
                        <div class="rewards_content" :id="`${baseId}-rewards-${index}-brushstroke-banner-rewards-content`">
                            <v-layout :id="`${baseId}-rewards-${index}-brushstroke-banner-rewards-content-layout`">
                                <v-flex
                                    class="rewards_holder" :class="[{ increase_height_for_no_expiration: !showTierExpiration && !shortView }]"
                                    :id="`${baseId}-rewards-${index}-brushstroke-banner-rewards-content-flex`"
                                >
                                    <div
                                        :class="[{resize_text_in_short_view: shortView}, {pad_bottom_for_wide_view: showTierExpiration}]" class="rewards_credit tx-font-primary"
                                        :id="`${baseId}-rewards-${index}-brushstroke-banner-rewards-content-credit`"
                                    >{{ getCurrency(rewards.credits) }}</div>
                                    <div
                                        :class="[{resize_subtext_in_short_view: shortView}, {pad_bottom_for_wide_view: showTierExpiration}, {rewards_content_credit_label_hide_on_tablet: rewards.hideLabelOnTablet}]"
                                        class="rewards_credit_text pad_text_for_adjustment tx-font-primary"
                                        :id="`${baseId}-rewards-${index}-brushstroke-banner-rewards-content-credit-label`"
                                    >{{ rewards.label || $nsLanguage.getTranslation('rewardsBanner.enjoyCreditsLabel') }}</div>
                                    <div class="expires_number" :id="`${baseId}-rewards-${index}-brushstroke-banner-rewards-content-expires-container`">
                                        <div
                                            :class="[{resize_subtext_in_short_view: shortView}, {rewards_content_credit_text_hide_on_tablet: rewards.hideTextOnTablet}]" class="pad_text_for_adjustment rewards_credit_expires_in tx-font-primary"
                                            :id="`${baseId}-rewards-${index}-brushstroke-banner-rewards-content-expires-text`"
                                        >{{ rewards.expiration }}</div>
                                        <v-layout
                                            v-if="showTierExpiration"
                                            class="hide_div_on_narrow_view"
                                            :id="`${baseId}-rewards-${index}-brushstroke-banner-rewards-content-expires-date-container`"
                                        >
                                            <div
                                                class="expires_date rewards_subtext tx-font-primary"
                                                :id="`${baseId}-rewards-${index}-brushstroke-banner-rewards-content-expires-date`"
                                            >{{ $nsLanguage.getTranslation('exp') }}: {{rewards.expiresDate | moment('MM/DD/YYYY')}}</div>
                                        </v-layout>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-layout>
                </BrushstrokeBanner>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>

import BrushstrokeBanner from '@/components/common/BrushstrokeBanner.vue'
import { formatPoints } from '../services/points'

export default {
    components: {
        BrushstrokeBanner
    },
    computed: {
        baseId: function () {
            const defaultBase = 'rewards-status'
            if (this.parentId) {
                return `${this.parentId}-${defaultBase}`
            } else {
                return defaultBase
            }
        }
    },
    props: {
        rewardsValues: Array,
        showTierExpiration: Boolean,
        shortView: Boolean,
        parentId: {
            type: String,
            required: false,
            default: ''
        }
    },
    methods: {
        getCoinImage (color) {
            if (color === 'green') {
                return require('@/assets/rewards-coin.green.svg')
            }

            return require('@/assets/rewards-coin.blue.svg')
        },
        getCurrency (value) {
            return formatPoints(value)
        }
    }
}

</script>

<style lang="scss" scoped>

@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";

$color-blackhole: map.get(colors.$baseColors, blackhole);
$color-white: #FFFFFF;

.reward_card_override_left_top_bottom_pad {
    padding-left: 16px !important;
    padding-top: 9px;
    padding-bottom: 9px;
}
.pad_for_upper_banner {
    margin-top: 30px;
}

.violator {
    display: flex;
    justify-content: center;
    position: absolute;
    left: -1px;
    top: -20px;
    height: 20px;
    padding: 0 9px;
    background-color: $color-blackhole;
    border-radius: 0 !important;
    color: $color-white;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .8px;

    .violator-text {
        align-self: center;
        text-transform: uppercase;
    }
}

.reward_icon {
    display: flex;
    align-items: center;
    margin-right: 16px;
    height: 56px;
}

.reward_icon img {
    width: 56px;
}

.small_reward_icon {
    display: flex;
    align-self: center;
    align-items: center;
    margin-right: 16px;
    height: 36px;
}

.small_reward_icon img {
    width: 36px;
}

.rewards_content {
    display: flex;
    flex: 1;
    align-items: center;
}

.increase_height_for_no_expiration{
    height: 46px;
}

.rewards_holder{
    display: flex;
    align-items: center;
}

.rewards_credit {
    font-size: 30px;
    font-weight: 600;
    line-height: 30px;
    align-items: baseline;
}

.rewards_credit_text {
    margin-left: 8px;
    font-size: 16px;
    align-items: baseline;
    text-transform: initial;
}

.expires_number{
    font-size: 20px;
    flex: 1;
    align-items: baseline;
    text-align: right;
    font-style: italic;
    font-weight: 600;
}

.pad_text_for_adjustment{
    padding-bottom: 3px;
}

.rewards_subtext{
    color: rgba(0, 0, 0, 0.5);
    margin-top: 5px;
}

.earned_tier {
    text-align: left;
    align-items: baseline;
}

.expires_date {
    flex: 1;
    align-items: baseline;
    text-align: right;
    font-size: 16px;
    font-weight: normal;
    line-height: 1.125em;
}

.fillRemainder{
    flex: 1;
}

.resize_text_in_short_view {
    font-size: 18px;
    font-weight: 600;
    line-height: 36px;
}

.resize_subtext_in_short_view {
    font-size: 14px;
    line-height: 18px;
}

.pad_bottom_for_wide_view {
    margin-bottom: 15px;
}

@media screen and (max-width: 768px) {
    .rewards_content_credit_label_hide_on_tablet {
        display: none;
    }

    .rewards_content_credit_text_hide_on_tablet {
        display: none;
    }

    .reward_icon {
        display: flex;
        align-items: center;
        margin-right: 16px;
        height: 36px;
    }

    .reward_icon img {
        width: 36px;
    }

    .rewards_credit {
        font-size: 24px;
        line-height: 24px;
    }

    .rewards_credit_expires_in {
        font-size: 12px;
        font-weight: 500;
        line-height: 12px;
        padding-top: 2px;
    }

    .rewards_subtext, .hide_div_on_narrow_view {
        display: none;
    }

    .resize_text_in_short_view {
        line-height: 24px;
    }

    .resize_subtext_in_short_view {
        padding-top: 2px;
        line-height: 12px;
    }

    .small_reward_icon {
        margin-top: 2px;
    }

    .pad_bottom_for_wide_view {
        margin-bottom: 0;
    }

    .rewards_holder {
        flex-wrap: wrap;
    }

    .rewards_credit, .expires_number {
        width: 100%;
        text-align: left;
    }
}

</style>
